<div #wrapper class="wrapper" (hdisResize)="onResize($event)">
  <span *ngIf="loading">Loading...</span>
  <span *ngIf="error">Whoops something went wrong</span>
  <svg #chart class="chart"></svg>
</div>
